var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DEFAULT_ALERT_TITLE_UI, DEFAULT_DURATION } from './ErrorHandlers.constatns';
import EX_$InitErrorHandler from './initErrorHandler';
import { ErrorsCapture } from './ErrorsCapture';
/**
 * @description ErrorsCaptureWrapperUi is a wrapper of function ErrorsCapture
 * for pass client error config
 * @param {TCatchUiErrorsParams} params
 *
 */
var ErrorsCaptureWrapperUi = function (params) {
    var error = params.error, componentName = params.componentName, MethodCatchOn = params.MethodCatchOn, _a = params.PathCatchOn, PathCatchOn = _a === void 0 ? '-' : _a, _b = params.AdditionalInfo, AdditionalInfo = _b === void 0 ? '-' : _b, alertConfig = params.alertConfig, _c = params.showAlertReportBtn, showAlertReportBtn = _c === void 0 ? EX_$InitErrorHandler.showAlertReportBtn : _c;
    var _d = __assign({}, alertConfig), _e = _d.title, title = _e === void 0 ? DEFAULT_ALERT_TITLE_UI : _e, _f = _d.duration, duration = _f === void 0 ? DEFAULT_DURATION : _f;
    ErrorsCapture({
        error: error,
        tag: 'client',
        componentName: componentName,
        MethodCatchOn: MethodCatchOn,
        PathCatchOn: PathCatchOn,
        AdditionalInfo: AdditionalInfo,
        alertTitle: title,
        alertDuration: duration,
        showAlertReportBtn: showAlertReportBtn
    });
};
export { ErrorsCaptureWrapperUi };
